module.exports = __webpack_public_path__ + "img/t2-c9.f35031ad.png";